// extracted by mini-css-extract-plugin
module.exports = {"con":"msg_con__1edMV","msg":"msg_msg__2zWMH","ico":"msg_ico__22fyg","bz":"msg_bz__3XGvN","tex":"msg_tex__3gG6R","err":"msg_err__1SSiW","close":"msg_close__Iwf2h"};